import { render, staticRenderFns } from "./invitaGana.vue?vue&type=template&id=25a61c25&scoped=true&"
import script from "./invitaGana.vue?vue&type=script&lang=js&"
export * from "./invitaGana.vue?vue&type=script&lang=js&"
import style0 from "./invitaGana.vue?vue&type=style&index=0&id=25a61c25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a61c25",
  null
  
)

export default component.exports